module.exports = __webpack_public_path__ + "img/lens-167-plus-05.ed793984.png";